<template>
  <div class="scanlist">
    <!-- <ul>
      <li>姓名：&emsp;&emsp;<span v-text="NAME"></span></li>
      <li>排队号：&emsp;<span v-text="NUMBER"></span></li>
      <li>下一站：&emsp;<span class="mark" v-text="STATION"></span></li>
      <li>等待人数：<span class="mark" v-text="WAITING"></span></li>
    </ul> -->
      <section class="name" v-text="NAME"></section>
      <section class="container">
        <div class="next">下一站</div>
        <div class="station" v-text="STATION">心电图站（A06）</div>
        <div class="number">等待人数：<span v-text="WAITING"></span></div>
      </section>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        NAME: this.$route.query.NAME,
        STATION: this.$route.query.STATION,
        WAITING: this.$route.query.WAITING,
        NUMBER: this.$route.query.NUMBER,
      }
    }
  }

</script>
<style lang="less" scoped>
  .scanlist {
    position: fixed;
    width: 100%;
    height: 100%;
    padding: 100px 40px;
    box-sizing: border-box;
    background: #f8fafa;
    .name{
      font-size: 18px;
      padding:10px 15px;
    }
    .container{
      padding: 10px 40px;
      border:1px solid #57b75c;
      border-radius: 10px;
      background: #fff;
      .next{
        padding:10px 15px;
      }
      .station{
        height: 45px;
        line-height: 45px;
        text-align: center;
        font-size: 22px;
        color:#fff;
        border-radius: 10px;
        background:  linear-gradient(to right, #71cc21 , #44ddbe);
      }
      .number{
        padding:10px 15px;
        span{
          display: inline-block;
          width: 40px;
          height: 18px;
          line-height: 20px;
          border-radius: 9px;
          text-align: center;
          color:#fff;
          background:  linear-gradient(to right, #71cc21 , #44ddbe);
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/scanResult.vue